// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import '@/assets/css/main.css'
import '@/assets/css/iconfont/iconfont'
import '@/assets/css/cookie.css'
import Vue from 'vue'
import App from './App'
import './index'
import router from './router'
import { initAppConfig } from './config'
import {initAegis} from './utils/aegis'
import { loadCaptchaScript } from './utils/captcha'

(async () => {
  const success = await initAppConfig()
  if (success) {
    loadCaptchaScript()
    initAegis()
    Vue.config.productionTip = false
    /* eslint-disable no-new */
    new Vue({
      el: '#app',
      router,
      components: { App },
      template: '<App/>'
    })
  }
})()



// WEBPACK FOOTER //
// ./src/main.js